<template>
    <span :class="className" class="icon">
        <slot name="default" :index="themeModeIndex">
    
        </slot>
    </span>

</template>

<script>
    import { mapState, mapGetters } from 'vuex' 
     export default {
        inheritAttrs: false,
        props: ['className',],
        computed: {
            ...mapState(['themeMode','icon']),
            ...mapGetters(['isMobile', 'themeModeIndex'])
        }
    }
</script>

<style scoped>
.icon {
    display: flex;
}
</style>
